import React, { Component, forwardRef } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import Modal from 'react-bootstrap/Modal';
import { connect } from "react-redux";
import { toastError, toastSuccess, DOC_BASE_URL, countryActionId, downloadReport, gstValidationListActionId, businessSectorActionId, primaryServicesActionId, exportMarketsActionId, documentsListActionId, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from '../../../utils/pagination'
import DatePicker from "react-datepicker";
import Workbook from 'react-excel-workbook'
import Header from '../../../common_components/Header';
import { fetchReceiptList_action, getReceiptPdf_action, receiptShare_action } from '../../../actions/adminAction/receipt_action'


const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        value={value}
        className="form-control"
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    ></input>
));


class ReceiptList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            companyName: "",
            recptDtFrom: "",
            recptDtTo: "",
            recptNo: "",
            currentPage: 1,
            recordsPerPage: 10,
            toEmail: '',
            ccEmail: '',
            attachedment: [],
            fileList: FileList | null,
            isOpen: false,
            recptList: [],
            excelList: [],
            isAllChecked: false,
            isOpen: false,
            taxableAmount: 0,
            totalReceivedAmt: 0,
            totalSD: 0,
            loginAccesslist: [],
            // isRightToAdd: false,
            // isRightToEdit: false,
            // isRightToView: false,

            //Error Msg
            companyNameErr: "",
            recptDtFromErr: "",
            recptDtToErr: "",
            recptNoErr: "",
            checkBoxFlag: true,
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.getReceiptList = this.getReceiptList.bind(this);
        this.onSearchClick = this.onSearchClick.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleAllSelected = this.handleAllSelected.bind(this)
        this.onCreateExcel = this.onCreateExcel.bind(this)
        this.handleListClick = this.handleListClick.bind(this)
        this.handleView = this.handleView.bind(this)
        this.handleShare = this.handleShare.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.handleNewReceipt = this.handleNewReceipt.bind(this)
        this.calculateTotals = this.calculateTotals.bind(this)
        this.handleRemoveFile = this.handleRemoveFile.bind(this)
        // this.getEmailData = this.getEmailData.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.onReceiptDownload = this.onReceiptDownload.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
        this.getDownloadAccess = this.getDownloadAccess.bind(this)
        this.getSendAccess = this.getSendAccess.bind(this)
        this.getUpdateAccess = this.getUpdateAccess.bind(this)
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const InvoiceListModule = loginAccessList.find(module => module.ModuleName === "Receipt List");

            if (InvoiceListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = InvoiceListModule;

                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login'); // Navigate to login if no access
                } else {
                    this.setState({
                        FullAccess: !!FullAccess,
                        ReadAccess: !!ReadAccess,
                        WriteAccess: !!WriteAccess,
                        UpdateAccess: !!UpdateAccess,
                        DeleteAccess: !!DeleteAccess,
                        DownloadAccess: !!DownloadAccess,
                        Is_SpecialAccess: !!Is_SpecialAccess,
                        SendAccess: !!SendAccess
                    });

                    if (FullAccess) {
                        this.setState({
                            ReadAccess: true,
                            WriteAccess: true,
                            UpdateAccess: true,
                            DeleteAccess: true,
                            DownloadAccess: true,
                            Is_SpecialAccess: true,
                            SendAccess: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }

            if (loginAccessList.length) {
                sessionStorage.setItem("currentPage", 'receiptList')
                this.getReceiptList()
                this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
            }
        }
    }

    // Search Receipt 
    getReceiptList() {
        const { isLoading, companyName, recptDtFrom, recptDtTo, recptNo, currentPage } = this.state
        // Input Validate before search
        // this.InputValidate()

        // if (companyName !== "" && recptDtFrom !== "" && recptDtTo !== "" && recptNo !== "") {
        this.setState({ isLoading: true })
        this.props
            .fetchReceiptList_action(companyName, recptDtFrom, recptDtTo, recptNo)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data, '[][]')
                    data.data.forEach(item => {
                        item.is_checked = 0
                    })
                    this.setState({
                        recptList: data.data,
                    })
                    setTimeout(() => {
                        console.log("aaaaaaaaaaaaa", data.data);
                        this.updateItem(currentPage)
                        this.setState({ isLoading: false })
                    }, 500);
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    //For Calculation All total Amounts in table 
    calculateTotals(list) {

        const { recptList, currentPage } = this.state


        let TaxableAmount = 0;
        let toatalSD = 0
        let totalCgst = 0;
        let totalIgst = 0;
        let totalSgst = 0;
        let TotalReceivedAmt = 0;

        console.log("recptList", recptList)

        list.length > 0 && list.forEach((data) => {
            console.log("00000", data.TaxableAmount)

            TaxableAmount += Number(data.TaxableAmount);
            toatalSD += Number(data.SecurityDeposite);
            totalCgst += Number(data.CGST);
            totalIgst += Number(data.IGST);
            totalSgst += Number(data.SGST);
            TotalReceivedAmt += Number(data.Amount)
            console.log("00000", TaxableAmount)

        });

        this.setState({
            totalReceivedAmt: TotalReceivedAmt.toFixed(2),
            taxableAmount: TaxableAmount.toFixed(2),
            totalSD: toatalSD.toFixed(2)
        })
        return {
            TaxableAmount,
            totalCgst,
            totalIgst,
            totalSgst,
            TotalReceivedAmt
        };
    }


    handleAllSelected(e) {
        const { recptList, isAllChecked } = this.state
        if (isAllChecked) {
            recptList.map(data => {
                data.is_checked = 0
            })
            this.setState({ isAllChecked: false, excelList: [], recptList: recptList })

        } else {
            recptList.map(data => {
                data.is_checked = 1
            })
            this.setState({ isAllChecked: true, recptList: recptList, excelList: recptList })
        }

        // this.setState({ recptList: recptList, excelList: recptList, isAllChecked: !isAllChecked })

        const checkboxSelected = recptList.some(item => item.is_checked == 1)
        if (checkboxSelected) {
            this.setState({ checkBoxFlag: false })
        } else {
            this.setState({ checkBoxFlag: true })
        }
    }

    // Update Current Page
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };

    clearValue() {
        this.setState({
            companyName: "",
            recptDtFrom: "",
            recptDtTo: "",
            recptNo: "",
        })
        setTimeout(() => {
            this.getReceiptList()
        }, 500);
    }

    handleKeyDown(e) {
        if (e.code == 'Enter') {
            this.getReceiptList()
        }
    }

    // to create excel file
    onCreateExcel() {
        const { excelList, recptList } = this.state
        var list = []
        for (var i = 0; i < excelList.length; i++) {
            var obj = { ...excelList[i] }
            list.push(obj)
        }

        list.length > 0 && list.map(data => {
            delete data.BaseAmount
            delete data.ReceiptID
            delete data.is_checked

        })
        console.log("excelList", excelList)
        var columnArray = [],
            rowData = [];
        // for column data 
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, index) => {
                    columnArray.push(key)
                })
            }
        })

        // for row data
        list.map((data, index) => {
            rowData.push(data)
        })

        // console.log("rowData", rowData)
        // this.setState({
        //     columnArrayData: columnArray,
        //     rowData: rowData
        // })

        // { this.renderList() }
        console.log(rowData, columnArray, list)
        return (
            // <div className="row text-center" >
            <>
                {excelList.length > 0 ? <Workbook filename="RceiptList.xlsx" style={{}} element={
                    <button type="button" className='btn btn-primary mr-2  ms-2'
                        disabled={!this.getWriteAccess()}
                    >
                        Excel
                    </button>
                }>
                    <Workbook.Sheet data={rowData} name="Sheet A">
                        {columnArray.map((value, index) =>
                            <Workbook.Column label={value} value={value} />
                        )
                        }
                    </Workbook.Sheet>
                </Workbook> : <button type="button" className='btn btn-primary mr-2  ms-2' disabled={true}>
                    Excel
                </button>}
            </>
            // </div>
        );
    }

    onShare(receiptId) {
        const { recptList } = this.state
        const receiptIdArray = []
        console.log("receiptIdArray receiptId ", receiptId)
        recptList.map((data) => {
            if (data.is_checked === 1) {
                receiptIdArray.push(
                    {
                        "ReceiptID": data.ReceiptID
                    }
                )
            }
        })

        const singleReceiptIdArray = []
        singleReceiptIdArray.push(
            {
                "ReceiptID": receiptId
            }
        )

        console.log("receiptIdArray", receiptIdArray)

        this.setState({ isLoading: true })
        this.props
            .receiptShare_action(receiptId != undefined ? singleReceiptIdArray : receiptIdArray)
            .then((data) => {
                if (data.error != 1) {
                    console.log("receipt share !!!!!!!!!!!!", data.data);
                    this.setState({ isLoading: false })
                    toastSuccess("Receipt share successfully!", {
                        theme: 'colored',
                        autoClose: 500,
                        hideProgressBar: true,
                    })
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    handleListClick(e, id) {
        const { excelList, recptList, isAllChecked } = this.state
        console.log('000', recptList, excelList)
        var list = []
        recptList.map((data, index) => {
            if (data.ReceiptID == id) {
                if (!data.is_checked) {
                    data.is_checked = 1
                    excelList.push(data)
                } else {
                    data.is_checked = 0
                    list = excelList.filter((data) => data.ReceiptID != id)
                    this.setState({ excelList: list, isAllChecked: false })
                }
            }
        })

        this.setState({ recptList: recptList })
        const checkboxSelected = recptList.some(item => item.is_checked == 1)
        if (checkboxSelected) {
            this.setState({ checkBoxFlag: false })
        } else {
            this.setState({ checkBoxFlag: true })
        }

        const allSelected = recptList.every(item => item.is_checked == 1)

        if (allSelected) {
            this.setState({ isAllChecked: true })
        } else {
            this.setState({ isAllChecked: false })
        }

    }

    handleView(id) {
        this.props.navigate('/receiptAU', { state: { is_view: true, receiptId: id } })
    }

    handleUpdate(id) {
        this.props.navigate('/receiptAU', { state: { is_update: true, receiptId: id } })
    }

    handleNewReceipt() {
        this.props.navigate('/receiptAU', { state: { is_add: true, From: "ReceiptList" } })
    }

    handleRemoveFile(id) {
        const { ccEmail, toEmail, attachedment, fileList } = this.state
        //   const files = fileList ? [...fileList] : [];
        // this.setState({fileList : files.filter((file, i) => id != i )})
        //   console.log(" files.filter((file, i) => id != i ) ",  files.filter((file, i) => id != i ))

    }

    handleShare() {
        const { ccEmail, toEmail, attachedment, fileList } = this.state
        // console.log('fileList', fileList)
        // if (!fileList) {
        //   return;
        // }
        // const fileData = new FormData();
        // fileList.forEach((file, i) => {
        //   fileData.append(`file-${i}`, file, file.name);
        // });
        // console.log('fileData', fileData)

        this.setState({ isLoading: true })
        this.props
            .shareEmail_action(ccEmail, toEmail, fileList)
            .then((data) => {
                if (data.error != 1) {
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    toggleModal() {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }
    onSearchClick() {
        const { companyName, recptDtFrom, recptDtTo, recptNo } = this.state
        if (companyName != "" || recptDtFrom != null || recptDtTo != null || recptNo != "") {
            this.getReceiptList()
        } else {
            toastError("Atleast Fill One field to Search")
        }
    }

    // on pdf receipt download
    onReceiptDownload(E, id) {
        this.setState({ isLoading: true })
        this.props.getReceiptPdf_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '6');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    render() {
        const { companyName, recptDtFrom, recptDtTo, recptNo, isLoading, currentPage, recptList, attachedment,
            recptDtFromErr, recptDtToErr, recptNoErr, companyNameErr, isOpen, ccEmail, toEmail, isAllChecked, fileList,
            taxableAmount, totalReceivedAmt, checkBoxFlag, isFilterShow, recordsPerPage,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = recptList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(recptList.length / recordsPerPage)


        // const { taxableAmount, totalCgst, totalIgst, totalSgst, totalReceivedAmt } = this.calculateTotals()
        // const files = fileList ? [...fileList] : [];

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {/* {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <companyNameHeader /> : <HeaderWithLogo />
                } */}
                <Header />
                <section class="receipt-section" style={{ marginBottom: '50px', marginTop: '125px' }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-lg-12">
                                <div className="card shadow-none border mb-2" >
                                    <div className="card-header py-1">
                                        <h6 className='pt-2' style={{ float: 'left' }}>Receipt List</h6>
                                        <div style={{ float: 'right' }}>
                                            {(sessionStorage.getItem('RoleIDSS') == 1 || sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 3) && < button className='btn btn-primary mr-2 ms-2' onClick={() => this.handleNewReceipt()}>
                                                New Receipt
                                            </button>}
                                            {(sessionStorage.getItem('RoleIDSS') == 1 || sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 3) && this.onCreateExcel()
                                            }
                                            {(sessionStorage.getItem('RoleIDSS') == 1 || sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 3) && < button className='btn btn-primary mr-2  ms-2' disabled={checkBoxFlag}
                                                onClick={() => this.onShare()}
                                            >
                                                Share
                                            </button>}
                                            {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                <a href="javascript:void(0);"
                                                    className="btn btn-purple custom_btn"
                                                    title="Filter"
                                                    data-toggle="modal"
                                                    data-target="#filter_modal"
                                                    onClick={() => this.toggleFilterCollapse()}
                                                >
                                                    <i className="fa fa-filter" />
                                                </a>

                                            </> : <></>}
                                        </div>
                                    </div>
                                    <ul className="list-group list-group-flush" >
                                        {isFilterShow && <>
                                            {(sessionStorage.getItem('RoleIDSS') == 1 || sessionStorage.getItem('RoleIDSS') == 2 || sessionStorage.getItem('RoleIDSS') == 3) &&
                                                <li className="list-group-item">
                                                    <div className="row ">
                                                        <div className="col-xl-2 mb-3">
                                                            <div class="form-group">
                                                                <label>Company</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    defaultValue=""
                                                                    required=""
                                                                    value={companyName}
                                                                    onKeyDown={e => this.handleKeyDown(e)}
                                                                    onChange={(e) => this.setState({ companyName: e.target.value, companyNameErr: "" })}
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 mb-3">
                                                            <div class="form-group">
                                                                <label>Receipt Date From</label>
                                                                <DatePicker className="form-control"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    onKeyDown={e => this.handleKeyDown(e)}
                                                                    onChange={(date) => this.setState({ recptDtFrom: date, recptDtFromErr: "" })}
                                                                    selected={this.state.recptDtFrom}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="From Date"
                                                                    customInput={<ExampleCustomInput />}
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class"
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{recptDtFromErr}</span>} */}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 mb-3">
                                                            <div class="form-group">
                                                                <label>Receipt Date To</label>
                                                                <DatePicker className="form-control"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    minDate={this.state.recptDtFrom}
                                                                    onKeyDown={e => this.handleKeyDown(e)}
                                                                    onChange={(date) => this.setState({ recptDtTo: date, recptDtToErr: "" })}
                                                                    selected={this.state.recptDtTo}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="To Date"
                                                                    customInput={<ExampleCustomInput />}
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class"
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{recptDtToErr}</span>} */}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 mb-3">
                                                            <div class="form-group">
                                                                <label>Receipt No</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    value={recptNo}
                                                                    onKeyDown={e => this.handleKeyDown(e)}
                                                                    onChange={(e) => this.setState({ recptNo: e.target.value, recptNoErr: "" })}
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{recptNoErr}</span>} */}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 mb-3">
                                                            < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getReceiptList()}>
                                                                Search
                                                            </button>
                                                            <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark  mr-2 ms-2' onClick={e => this.clearValue()}>
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </li>}
                                        </>}

                                    </ul>
                                </div>
                                <div class="card shadow-none border">
                                    <div class="card-body p-2 pb-0">
                                        <div class="custom_table">
                                            <div class="hack1">
                                                <div class="hack2">
                                                    <table class="table table-bordered table-striped mg-b-0">
                                                        <thead>
                                                            <tr>
                                                                {
                                                                    parseInt(sessionStorage.getItem('RoleIDSS')) != 5 &&
                                                                    <th className="text-center">
                                                                        <input type="checkbox" class="custom-control-input" value={isAllChecked} checked={isAllChecked} />
                                                                        <label style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} class="custom-control-label" onClick={(e) => this.handleAllSelected(e)}></label>
                                                                    </th>
                                                                }
                                                                {/* <th>Reference No </th> */}
                                                                <th>Receipt No</th>
                                                                {
                                                                    // JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                                                    <th>Company Name</th>
                                                                }
                                                                <th>Receipt Date </th>
                                                                <th>Taxable Amount </th>
                                                                <th>Security Deposit </th>
                                                                <th>CGST </th>
                                                                <th>SGST </th>
                                                                <th>IGST </th>
                                                                <th>Receipt Amount</th>
                                                                {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 && <th>Receipt Bank </th>}
                                                                <th></th>
                                                                {/* <th></th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody id='myTable'>
                                                            {
                                                                currentRecords.length > 0 ?
                                                                    currentRecords.map((data, index) => (
                                                                        <>
                                                                            <tr >
                                                                                {
                                                                                    parseInt(sessionStorage.getItem('RoleIDSS')) != 5 &&
                                                                                    <td className="text-center" style={{ paddingRight: '20px' }}>
                                                                                        {/* <input type="checkbox"
                                                                                            value={data.is_checked}
                                                                                            checked={data.is_checked}
                                                                                            onClick={e => this.handleListClick(e, data.ReceiptID)} /> */}

                                                                                        <input type="checkbox" class="custom-control-input" value={data.is_checked} checked={data.is_checked} onClick={(e) => this.handleListClick(e, data.ReceiptID)} />
                                                                                        <label onClick={(e) => this.handleListClick(e, data.ReceiptID)} class="custom-control-label" style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} ></label>
                                                                                    </td>
                                                                                }
                                                                                {/* <td>{data.ReferenceNo}</td> */}
                                                                                <td>{data.ReceiptNo}</td>
                                                                                {
                                                                                    // JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                                                                    <td>{data.CompanyName}</td>
                                                                                }
                                                                                <td>{data.ReceiptDate}</td>
                                                                                <td>{data.TaxableAmount}</td>
                                                                                <td>{data.SecurityDeposite}</td>
                                                                                <td>{data.CGST}</td>
                                                                                <td>{data.SGST}</td>
                                                                                <td>{data.IGST}</td>
                                                                                <td>{data.Amount}</td>
                                                                                {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 && <td>{data.ReceiptBank}</td>}

                                                                                <td style={{ cursor: 'pointer', textAlign: 'center', width: '10%' }}>
                                                                                    {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 && <i className="fa fa-eye mx-2" title='view' aria-hidden="true" onClick={e => this.handleView(data.ReceiptID)}
                                                                                    // disabled={!isRightToView}
                                                                                    />}
                                                                                    {
                                                                                        this.getUpdateAccess() &&
                                                                                        < i className="fa fa-pencil mx-2" title='update' aria-hidden="true" onClick={e => this.handleUpdate(data.ReceiptID)}
                                                                                        // disabled={!isRightToEdit}
                                                                                        />
                                                                                    }
                                                                                    {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 ? <i className="fa fa-download mx-2" aria-hidden="true" title='download' onClick={(e) => this.onReceiptDownload(e, data.ReceiptID)} /> :
                                                                                        <a style={{ marginRight: '10px', color: 'white', background: '#744587', padding: '2px 10px', borderRadius: '8px' }}
                                                                                            title="Download Document"
                                                                                            onClick={(e) => this.onReceiptDownload(e, data.ReceiptID)}
                                                                                        >
                                                                                            Download
                                                                                        </a>}

                                                                                    {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 && <i class="fa fa-share mx-2" title='share'
                                                                                        onClick={(e) => this.onShare(data.ReceiptID)}
                                                                                    ></i>}
                                                                                </td>

                                                                            </tr>
                                                                        </>
                                                                    )) : <tr><td colSpan={12} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }
                                                            {
                                                                currentRecords.length > 0 &&
                                                                <tr>
                                                                    {/* <td /> */}
                                                                    {
                                                                        parseInt(sessionStorage.getItem('RoleIDSS')) != 5 &&
                                                                        <td />
                                                                    }
                                                                    {
                                                                        // JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                                                        <td />
                                                                    }
                                                                    <td />
                                                                    <td />
                                                                    <td>
                                                                        <strong>{taxableAmount}</strong>
                                                                    </td>
                                                                    <td>
                                                                        <strong>
                                                                            {/* {this.state.totalSD} */}
                                                                        </strong>
                                                                    </td>
                                                                    <td>
                                                                        <strong></strong>
                                                                    </td>
                                                                    <td>
                                                                        <strong></strong>
                                                                    </td>
                                                                    <td>
                                                                        <strong></strong>
                                                                    </td>
                                                                    <td>
                                                                        <strong>{totalReceivedAmt}</strong>
                                                                    </td>
                                                                    <td />
                                                                    {parseInt(sessionStorage.getItem('RoleIDSS')) != 5 && <td />}
                                                                    {/* <td /> */}
                                                                </tr>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-2 float-left">
                                            {
                                                recptList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                        totalRecords={recptList.length}
                                                        pageLength={recordsPerPage}
                                                        setPageLength={this.updateRecordsPerPage}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </section >
            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, fetchReceiptList_action, getReceiptPdf_action, receiptShare_action })(ReceiptList));